import $ from 'jquery';
$(function () {
    $('.g-map').each(function (i, m) {
        initMap($(m).prop('id'), $(m).data('lat'), $(m).data('lon'), $(m).data('stations'), $(m).data('zoom'), $(m).data('icon'), $(m).data('svg'))
    });
});

async function initMap(mapId, lat, lon, stations, zoom, icon, svg) {
    // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
        "marker",
    );

    if (!zoom || zoom==0) {
        zoom = 10;
    }

    const map = new google.maps.Map(document.getElementById(mapId), {
        center: new google.maps.LatLng(lat, lon),
        zoom: zoom,
        mapId: 'Map-' + mapId,
        mapTypeControl: false
    });

    if (stations) {
        for (let i = 0; i < stations.length; i++) {
            const train = document.createElement("img");
            train.src = "/v2/icons/map-station.svg";

            const marker = new google.maps.marker.AdvancedMarkerElement({
                map,
                position: new google.maps.LatLng(stations[i].Lat, stations[i].Lon),
                content: train,
            });
        }
    }

    if (icon) {
        const img = document.createElement("img");
        img.src = icon;

        const iconMarker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: new google.maps.LatLng(lat, lon),
            content: img,
        });
    }

    if (svg) {
        const dv = document.createElement("div");
        dv.classList.add('map-marker');
        dv.classList.add(svg);
        dv.attributes['height'] = 45;
        dv.attributes['width'] = 45;
        dv.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 33 45" fill="none"><path d="M33 16.3047C33 7.29956 25.6122 0 16.5018 0C7.39153 0 0 7.29956 0 16.3047C0 19.938 1.2061 23.2945 3.2384 26.0058L3.2089 26.035L16.4982 45L29.7874 26.035L29.7579 26.0058C31.7939 23.2945 32.9963 19.938 32.9963 16.3047H33Z" /></svg>';

        const iconMarker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: new google.maps.LatLng(lat, lon),
            content: dv,
        });
    }
}